import { Box, Card, Flex, type BoxProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

type WidgetShellProps = BoxProps & {
  title: ReactNode
  headerAfterTitle?: ReactNode
  headerRight?: ReactNode
  headerBottom?: ReactNode // optional sub-header row (e.g. year selector, filters)
  children: ReactNode
}

export function WidgetShell({
  title,
  headerAfterTitle,
  headerRight,
  headerBottom,
  children,
  ...boxProps
}: WidgetShellProps) {
  return (
    <Card.Root w="full" {...boxProps}>
      <Card.Header>
        <Flex
          justify="space-between"
          align="center"
          gap={4}
          wrap="nowrap"
          alignItems={{ base: 'start', md: 'center' }}
          direction={{ base: 'column', md: 'row' }}
        >
          <Flex
            align="center"
            justifyContent={{ base: 'space-between', md: 'flex-start' }}
            gap={3}
            wrap="wrap"
            w="full"
            minW={0}
          >
            <Card.Title>{title}</Card.Title>

            {headerAfterTitle ? <Flex minW={0}>{headerAfterTitle}</Flex> : null}
          </Flex>

          {headerRight ? <Flex>{headerRight}</Flex> : null}
        </Flex>

        {headerBottom ? <Box>{headerBottom}</Box> : null}
      </Card.Header>

      <Card.Body>{children}</Card.Body>
    </Card.Root>
  )
}
